import { useNavigate } from "react-router-dom";

import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { questionContent } from "../questions";
import ConfirmationWithDetailQuestion from "../../../components/Questions/ConfirmationWithDetailQuestion";

const DailyActivity: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (answer?: ConfirmationAnswer, detail?: string) => {
    setAnswers({
      ...answers,
      dailyActivity: answer ?? answers.dailyActivity,
      dailyActivityDetail:
        answer !== ConfirmationAnswer.Yes ? undefined : detail,
      ...(answer !== ConfirmationAnswer.Yes
        ? { dailySupport: undefined, dailySupportDetail: undefined }
        : {}),
    });
  };

  const onContinue = () => {
    if (answers.dailyActivity === ConfirmationAnswer.Yes) {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.DailySupport}`);
    } else {
      navigate(`/${PATHS.Summary}`);
    }
  };

  const placeholder = "Please let us know how this impacts you day to day";

  return (
    <ConfirmationWithDetailQuestion
      onChange={onChange}
      value={answers.dailyActivity}
      detail={answers.dailyActivityDetail}
      onContinue={onContinue}
      step={questionContent.dailyActivity.step}
      title={questionContent.dailyActivity.title}
      whyWeWantTexts={questionContent.dailyActivity.whyWeWantTextsCustomer}
      placeholder={placeholder}
    />
  );
};

export default DailyActivity;
